import React, { FC } from 'react';
import campaignSearchIcon from 'assets/img/campanhas-de-marketing/search.svg';
import { UseCampanhaContext } from 'context/campanha-context';
import { UseCampanhaHook } from 'hooks/campanha-hook';
import { SearchProps } from 'models/campaign-mkt';
import { Container, InputWrapper, PlaceholderStyled } from './styles';

const SearchBox: FC<SearchProps> = ({
  placeHolder,
  width,
  height,
  variant = 'default',
}) => {
  const { filterOpened } = UseCampanhaContext();
  const { handleSearchChange, searchName } = UseCampanhaHook();

  return (
    <Container>
      <InputWrapper
        width={width}
        height={height}
        filterOpened={filterOpened}
        variant={variant}
      >
        {!searchName && variant === 'campaigns' && (
          <PlaceholderStyled>{placeHolder}</PlaceholderStyled>
        )}
        <input
          type="text"
          placeholder={variant === 'campaigns' ? '' : placeHolder}
          onChange={handleSearchChange}
          value={searchName}
        />
        <img className="pointer" src={campaignSearchIcon} alt="Search icon" />
      </InputWrapper>
    </Container>
  );
};

export default SearchBox;
